import React, { useEffect, useRef } from 'react';

// Textarea that grows with its content — no inner scrollbar, no manual resize
// handle. Field feedback: typing should push the box taller, not hide text.
const AutoGrowTextarea = ({ value, style, minHeight = 30, ...props }) => {
    const ref = useRef(null);
    useEffect(() => {
        const el = ref.current;
        if (!el) return undefined;
        const fit = () => {
            el.style.height = 'auto';
            el.style.height = `${Math.max(el.scrollHeight, minHeight)}px`;
        };
        fit();
        // First paint can measure before the surrounding table/flex layout
        // settles (near-zero width → huge wrapped height) — re-fit after
        // layout, and whenever the viewport changes.
        const raf = requestAnimationFrame(fit);
        window.addEventListener('resize', fit);
        return () => {
            cancelAnimationFrame(raf);
            window.removeEventListener('resize', fit);
        };
    }, [value, minHeight]);
    return (
        <textarea
            ref={ref}
            rows={1}
            value={value}
            style={{ overflow: 'hidden', resize: 'none', minHeight, boxSizing: 'border-box', ...style }}
            {...props}
        />
    );
};

export default AutoGrowTextarea;
